/*
 * Copyright (C) 2017 BossieTech Co.,Ltd. All Rights Reserved.
 * Creator  :   Alfred
 * Date     :   2018/11/09
 */
import request from '@/utils/request'
import qs from 'qs'

// 获取流程任务列表，支持分页，搜索，排序
export function getWorkFlowTableData(params) {
  return request({
    url: `/workflowtasks`,
    method: 'get',
    params
  })
}
// 获取工作流任务所属实例的流程进度信息
export function getWorkFlowTasksSchedule(id) {
  return request({
    url: `/workflowtasks/${id}/schedule`,
    method: 'get'
  })
}

// 获取流程实例列表，支持分页，搜索，排序
export function getWorkFlowInstances(params) {
  return request({
    url: `/workflowinstances`,
    method: 'get',
    params
  })
}
// 获取目标流程实例进度
export function getWorkFlowInstancesSchedule(id) {
  return request({
    url: `/workflowinstances/${id}/schedule`,
    method: 'get'
  })
}
// 删除目标流程实例
export function deleteWorkFlowInstance(id) {
  return request({
    url: `/workflowinstances/${id}`,
    method: 'delete'
  })
}
// 获取用户流程集合,以分类树的形式展现
export function getWorkFlowTargets(id, templateId) {
  const params = {
    templateId,
    endType: 0
  }
  return request({
    url: `/users/${id}/workflow`,
    method: 'get',
    params
  })
}
// 获取目标工作流任务信息
export function getWorkFlowTask(id) {
  return request({
    url: `/workflowtasks/${id}`,
    method: 'get'
  })
}
// 该接口可处理工作流任务的新建，暂存，和提交动作，其本质上都是创建新的工作流任务
// 具体功能按以下描述的先后顺序作为处理优先级
// 1、如果工作流任务id非空，则认为是提交目标任务，此时将忽略ship参数进行处理
// 2、如果工作流定义workflowId非空,并且ship=1，则认为是发起某项新的工作流, 并尝试将工作流任务推向下一步
// 3、如果工作流定义workflowId非空,并且ship=0，则认为是发起某项新的工作流, 但不推动任务流转，任务停留在初始的pending状态
export function handleWorkFlowTask(workFlowId, id, ship, data = {}, submit) {
  const params = { workFlowId, id }
  let str = ''
  if (submit) {
    params.opinion = submit.opinion
    params.opinionNote = submit.opinionNote
    params.option = submit.option
    params.nextId = submit.nextId === undefined ? 0 : submit.nextId
    str = submit.candidate.map(sc => {
      return `candidate=${sc}`
    }).join('&')
  } else {
    params.nextId = 0
    params.option = 0
  }
  if (params.option === 0 || params.option === undefined) {
    return request({
      url: `/workflowtasks?${str}`,
      method: 'post',
      params,
      data
    })
  } else {
    return request({
      url: `/workflowtasks/${id || 0}`,
      method: 'post',
      params,
      data
    })
  }
}
// 修改工作流任务属性
// 1、action=handle 办理前调用，修改流程任务状态为处理中,修改后改待办任务将不出现在其他待办人列表中，但会出现在自己的待办中；该接口需判定返回值
// 2、action=revert 取消办理时调用，恢复流程状态,可忽略接口的返回值，即使返回错误
// 3、action=finish 待阅变为已阅
export function changeWorkFlowTaskAction(id, action) {
  const params = {
    action
  }
  return request({
    url: `/workflowtasks/${id}`,
    method: 'patch',
    params
  })
}
// 获取目标流程任务提交时的待办候选人列表
// 1、在已有任务上提交时使用Id参数;
// 2、针对发起时的提交，使用activityId参数，因为此时流程任务还未创建
export function getWorkFlowTaskCandidate(id, workFlowId, data) {
  const params = {
    workFlowId
  }
  return request({
    url: `/workflowtasks/${id}/candidate`,
    method: 'post',
    params,
    data
  })
}
// 暂存工作流任务相关的单据信息, 但不提交工作流任务
export function saveWorkFlowTask(id, data) {
  return request({
    url: `/workflowtasks/${id}`,
    method: 'put',
    data
  })
}
// 待办提交
export function pushWorkFlowTask(params, data = {}) {
  if (params.option === 0) {
    const str = params.candidate.map(sc => {
      return `candidate=${sc}`
    }).join('&')
    delete params.candidate
    return request({
      url: `/workflowtasks?${str}`,
      method: 'post',
      params,
      data
    })
  } else {
    return request({
      url: `/workflowtasks/${params.id || 0}`,
      method: 'post',
      params,
      data
    })
  }
}
// 回退工作流任务，该接口可处理工作流的退回，退回到开始，撤回等任务
// 1、退回上一步 option=backward
// 2、撤回 option=withdraw
// 3、回到开头 option=backhead
export function backWorkFlowTask(id, params, data = {}) {
  return request({
    url: `/workflowtasks/${id}`,
    method: 'post',
    params,
    data
  })
}
// 获取模板流程节点
// 获取模板流程第一个流程步骤ID
export function getWorkFlowActivitys(id, workflowId, fields = null) {
  return request({
    url: `/workflowactivitys/${id}`,
    method: 'get',
    params: {
      workflow: workflowId,
      fields
    }
  })
}
// 获取下拉列表
export function getDataSpecCombo(id) {
  return request({
    url: `/combospecs/${id}/output`,
    method: 'get'
  })
}
// 获取指定流程任务的传送数据
export function getWorkflowPassData(id) {
  return request({
    url: `/workflowtasks/${id}/passdata`,
    method: 'get'
  })
}
export function getTargetWorkFlow(id) {
  return request({
    url: `/workflows/${id}`,
    method: 'get'
  })
}
// 获取用户流程事项的摘要信息
export function getWorkFlowStatistics(id) {
  return request({
    url: `/users/${id}/workflowtasks/statistics`,
    method: 'get'
  })
}
// 从待办数中获取用户可以处理的流程集合,以列表的形式展现
export function getWorkflowcategoryList(id, type) {
  const params = {
    type
  }
  return request({
    url: `/users/${id}/workflows/task`,
    method: 'get',
    params
  })
}
// 获取用户相关的流程事项
export function getWorkFlowTaskTableData(id, params) {
  return request({
    url: `/users/${id}/workflowtasks`,
    method: 'get',
    params
  })
}
// 获取用户相关的流程实例
export function getWorkflowObjects(id, params) {
  return request({
    url: `/users/${id}/workflowobjects`,
    method: 'get',
    params
  })
}
// 批量审批
export function batchSubmit(params) {
  return request({
    url: `/workflowtasks/batch`,
    method: 'post',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 获取目标流程结构信息
export function getWorkflowChart(id) {
  return request({
    url: `/workflows/${id}/structure`,
    method: 'get'
  })
}
// 获取用户通知的摘要信息
export function getNotifications(id) {
  return request({
    url: `/users/${id}/notifications/statistics`,
    method: 'get'
  })
}

// 获取流程实例步骤的描述信息
export function getTodoList(instanceId, activityId) {
  return request({
    url: `/workflowinstances/${instanceId}/${activityId}/info`,
    method: 'get'
  })
}

// 催办流程任务所属实例
export function urgeWorkFlowTask(id) {
  return request({
    url: `/workflowtasks/${id}/urge`,
    method: 'put'
  })
}

// 获取流程任务路径
export function getWorkFlowTaskPath(id) {
  return request({
    url: `/workflowtasks/${id}/path`,
    method: 'get'
  })
}

// 重新办理
export function resume(id) {
  return request({
    url: `/workflowinstances/${id}/resume`,
    method: 'post'
  })
}

// 改版api

// 获取用户流程事项的摘要信息
export function getWorkFlowStatistics_new(id) {
  return request({
    url: `/users/${id}/workflowtasks/statistics_new`,
    method: 'get'
  })
}

// 从待办数中获取用户可以处理的流程集合,以列表的形式展现
export function getWorkflowcategoryList_new(id, type, MainType) {
  const params = {
    type,
    MainType
  }
  return request({
    url: `/users/${id}/workflows/task_new`,
    method: 'get',
    params
  })
}

// 获取用户相关的流程事项
export function getWorkFlowTaskTableData_new(id, params) {
  return request({
    url: `/users/${id}/workflowtasks_new`,
    method: 'get',
    params
  })
}

// 获取用户相关的流程实例
export function getWorkflowobjectsCategoryList_new(id, type) {
  const params = {
    type
  }
  return request({
    url: `/users/${id}/workflowobjects/category`,
    method: 'get',
    params
  })
}
